// extracted by mini-css-extract-plugin
module.exports = {"scroller":"styles_scroller__xJaMZ","content":"styles_content__1U8xE"};